var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogleEmailIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16320_23022)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.375 0.5H5.625C2.5184 0.5 0 3.0184 0 6.125V18.875C0 21.9816 2.5184 24.5 5.625 24.5H18.375C21.4816 24.5 24 21.9816 24 18.875V6.125C24 3.0184 21.4816 0.5 18.375 0.5Z",
    fill: "#F4F2ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.90338 19.534H6.88631V12.2897L2.625 9.09375V18.2557C2.625 18.963 3.19819 19.534 3.90338 19.534Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1133 19.5341H20.0963C20.8037 19.5341 21.3747 18.9609 21.3747 18.2557V9.09375L17.1133 12.2898",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1133 6.75085V12.2906L21.3747 9.0947V7.38995C21.3747 5.80904 19.57 4.90773 18.3065 5.85592",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.88672 12.2899V6.75019L12.0003 10.5852L17.1139 6.75V12.2898L12.0003 16.1251",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.625 7.38995V9.09451L6.88631 12.2905V6.75085L5.69316 5.85592C4.42753 4.90773 2.625 5.80904 2.625 7.38995Z",
    fill: "#C5221F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16320_23022"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleEmailIcon);
export default __webpack_public_path__ + "static/media/GoogleEmailIcon.32c3bbadb3610138357c687f7a23ab88.svg";
export { ForwardRef as ReactComponent };